import React from "react";
import ActionListHeaderSheet from "../../sheet/ActionListHeaderSheet";

const SellerGroupHeaderSheet = props => {
    const { values, handleAction } = props;
    const actions = [
        {
            key: 1,
            title: "Supprimer",
            type: "remove"
        }
    ];

    return (
        <div className="headerSheet">
            <div className="infos">
                <p className={"titleSheet alone"}>{values.name}</p>
            </div>
            <ActionListHeaderSheet actions={ actions } handleAction={ handleAction } />
        </div>
    );
}

export default SellerGroupHeaderSheet;
